/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Lot_Debt_Filter_OwingInputs */

const vi_order_lot_debt_filter_owing = /** @type {(inputs: Order_Lot_Debt_Filter_OwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang nợ hàng`)
};

/**

* @param {Order_Lot_Debt_Filter_OwingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_debt_filter_owing = /** @type {((inputs?: Order_Lot_Debt_Filter_OwingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Debt_Filter_OwingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_debt_filter_owing(inputs)
});